import React, { Component } from "react";
import { DropzoneArea, DropzoneAreaProps, DropzoneDialogProps } from "material-ui-dropzone";
import { DropzoneDialog } from "material-ui-dropzone";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import clsx from "clsx";
import { v4 as uuidv4 } from "uuid";
import AlertsService from "../../services/alerts";
import { UIStyledTooltip } from "../../components/ui/UIComponents";
import { UIPageTitle } from "../../components/ui/UIPageTitle";
import { waitForElement, formatKB } from "../../utils";
import "./UploadDropZone.scss";
const MAX_FILE_SIZE: number = 31457280; // 30MB
export const MAX_500_MB: number = 524288000;
export const MAX_5GB: number = 5368709120; // default 5GB - AWS current limitation
export const ALL_FILES_TYPE: string[] = [];

type UploadDropZoneProps = {
	filename?: string;
	onFileSave: (files: File[]) => Promise<any>;
	onFilesDropped?: (files: File[]) => any;
	onFilesRejected?: (files: File[]) => any;
	onDialogClose?: () => any;
};

type UploadDropZoneState = {
	dialogOpen?: boolean;
	files: File[];
	saving: boolean;
};

// https://www.npmjs.com/package/material-ui-dropzone
export class UploadDropZoneArea extends Component<DropzoneAreaProps & UploadDropZoneProps, UploadDropZoneState> {
	private uploadMultipleFiles: boolean = false;
	private readonly maxFileSize: number = this.props.maxFileSize || MAX_FILE_SIZE;

	state = {
		files: [],
		saving: false,
	};

	render() {
		return (
			<DropzoneArea
				showPreviews={false}
				showAlerts={false}
				showPreviewsInDropzone={false}
				// showFileNamesInPreview={true}
				// showFileNames={true}
				onChange={handleChange.bind(this)}
				dropzoneText={`Drag and drop ${
					this.props.filename || `file${this.props.filesLimit === 1 ? "" : "/s"}`
				} here or click.`}
				onDrop={onFilesDropped.bind(this)}
				onDropRejected={onFilesRejected.bind(this)}
				clearOnUnmount={true}
				{...this.props}
				maxFileSize={this.maxFileSize}
				dropzoneParagraphClass="upload-drop-zone-text"
				// style={{ minHeight: "500px" }}

				// onChange={this.handleChange.bind(this)}
				// showFileNamesInPreview={true}
				// dropzoneText={`Drag and drop a ${this.props.filename} file here or click.`}
				// {...this.props}
			/>
		);
	}
}

function handleSave(files: File[]) {
	//Saving files to state for further use and closing Modal.
	console.log("handleSave. files:", files);
	this.setState({ files, dialogOpen: false, saving: true });
	this.props.onFileSave(files).finally(() => {
		this.setState({ saving: false });
	});
}

function handleChange(files: File[]) {
	console.log("handleChange. files:", files);
	if (this.props.filesLimit === 1) {
		handleSave.call(this, files);
		return;
	}
	this.setState({ files, saving: true, dialogOpen: false });
	setTimeout(() => {
		// by this point state should be updated with all files
		if (!this.uploadMultipleFiles) {
			this.uploadMultipleFiles = true;
			console.log("UploadDropZone multiple files. Uploading files:", this.state.files);
			this.props.onFileSave(this.state.files).finally(() => {
				this.setState({ saving: false });
				this.uploadMultipleFiles = false;
			});
		}
	}, 400);
}

function onFilesDropped(files: File[]) {
	console.log("UploadDropZone.onFilesDropped()", files);
	if (this.props.onFilesDropped) this.props.onFilesDropped(files);
}

function getMaxFileSizeDisplay(no: number): string {
	switch (no) {
		case MAX_500_MB:
			return "500MB";
		case MAX_5GB:
			return "5GB";
		case MAX_FILE_SIZE:
			return "30MB";
		default:
			return formatKB(no);
	}
}

function invalidFileSize(files: File[]): boolean {
	let msg: string;
	let invalidFileSize: boolean = false;
	for (let i = 0; i < files.length; i++) {
		const file: File = files[i];
		console.log("fileSize, maxSize:", file.size, this.maxFileSize);
		if (file.size > this.maxFileSize) {
			invalidFileSize = true;
		}
	}
	if (!invalidFileSize) return false;

	// const displayInMB: boolean = this.maxFileSize < 1000000000;
	// msg = `File size exceeded. Max file size: ${(displayInMB
	// 	? this.maxFileSize * 0.000001
	// 	: this.maxFileSize * 0.000000001
	// ).toLocaleString(undefined, {
	// 	maximumFractionDigits: 2
	// })}${displayInMB ? "MB" : "GB"}`;
	msg = `File size exceeded. Max file size: ${getMaxFileSizeDisplay(this.maxFileSize)}`;

	AlertsService.error(msg);
	if (this.props.onFilesRejected) {
		this.props.onFilesRejected(files);
	}
	return true;
}

function onFilesRejected(files: File[], evt) {
	console.log("onDropRejected:", files, evt);
	// determine reason - file type, size
	let msg: string;
	const _invalidFileSize: boolean = invalidFileSize.call(this, files);
	if (_invalidFileSize) return;
	msg = "Invalid file type. ";
	if (this.props.acceptedFiles && this.props.acceptedFiles.length <= 6) {
		msg += `File types supported: ${this.props.acceptedFiles}`;
	}
	AlertsService.error(msg);
	if (this.props.onFilesRejected) {
		this.props.onFilesRejected(files);
	}
}

export class UploadDropZoneDialogWithBtn extends Component<
	DropzoneDialogProps &
		UploadDropZoneProps & {
			displayIcon?: boolean;
			btnTxt?: any;
			containerClasses?: string;
			btnClasses?: string;
			btnTooltip?: string;
			btnRemoveClasses?: boolean;
			displayLoader?: boolean;
			disabled?: boolean;
			disabledTitle?: string;
			pageTitle?: string;
			onDialogOpen?: () => any;
			buttonRegUpload?: boolean;
			omitBtn?: boolean;
		},
	UploadDropZoneState
> {
	private uploadMultipleFiles: boolean = false;
	private readonly maxFileSize: number = this.props.maxFileSize || MAX_FILE_SIZE;
	private setRef: any;
	private fileInput: any;

	state = {
		dialogOpen: false,
		files: [],
		saving: false,
	};

	constructor(props: any) {
		super(props);

		this.setRef = (ref) => {
			this.fileInput = ref;
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.open !== this.state.dialogOpen) {
			if (this.props.open) this.handleOpen();
			else this.handleClose();
		}
	}

	handleInputChange(e: any, files: FileList) {
		e.preventDefault();
		e.stopPropagation();
		if (!files || !files.length || files.length < 1) {
			return; // user cancelled action
		}
		if (invalidFileSize.call(this, files)) return;
		handleChange.call(this, files);
	}

	handleClose() {
		console.log("UploadDropZone.handleClose()");
		this.setState({ dialogOpen: false });
		if (this.props.onDialogClose) this.props.onDialogClose();
	}

	handleOpen(e?) {
		e?.preventDefault();
		e?.stopPropagation();
		this.setState({ dialogOpen: true });
		if (this.props.onDialogOpen) this.props.onDialogOpen();
		if (this.props.pageTitle) {
			waitForElement(".MuiTypography-root.MuiTypography-h6", (el: any) => (el.innerText = this.props.pageTitle));
		} else if (this.props.filesLimit !== 1)
			waitForElement(".MuiTypography-root.MuiTypography-h6", (el: any) => (el.innerText = "Upload file/s"));
	}

	getBtn() {
		const button: any = this.props.displayIcon ? (
			<UIStyledTooltip
				title={this.props.disabled ? this.props.disabledTitle : this.props.btnTxt || "Select file"}
			>
				<span>
					<IconButton
						edge="start"
						aria-label={this.props.btnTxt}
						size="small"
						className="action-btn-icon upload-action-btn"
						disabled={this.props.disabled !== undefined ? this.props.disabled : this.state.saving}
						onClick={this.handleOpen.bind(this)}
					>
						<CloudUploadIcon fontSize="small" />
						{this.state.saving && <CircularProgress className="position-absolute" size={16} />}
					</IconButton>
				</span>
			</UIStyledTooltip>
		) : (
			<button
				className={clsx(!this.props.btnRemoveClasses && "btn btn-primary", this.props.btnClasses)}
				onClick={this.handleOpen.bind(this)}
				disabled={this.props.disabled !== undefined ? this.props.disabled : this.state.saving}
				title={this.props.disabled ? this.props.disabledTitle : undefined}
			>
				{this.props.btnTxt || "Select File"}
			</button>
		);

		if (this.props.buttonRegUpload) {
			const key = uuidv4()();
			const btn = (
				<label
					htmlFor={"corre-upload-file-input" + key}
					className={clsx(
						"corre-file-container",
						(this.state.saving || this.props.disabled) && " disabled",
						this.props.btnClasses,
						this.props.containerClasses
					)}
					onClick={(e) => {
						e.stopPropagation();
					}}
				>
					<span className="upload-text">{this.props.btnTxt || "Select File"}</span>
					<input
						id={"corre-upload-file-input" + key}
						type="file"
						ref={this.setRef}
						disabled={this.props.disabled !== undefined ? this.props.disabled : this.state.saving}
						accept={this.props.acceptedFiles.join(",")}
						capture="capture"
						multiple={false}
						onChange={(e) => this.handleInputChange(e, e.target.files)}
					/>
				</label>
			);
			if (this.props.btnTooltip)
				return (
					<UIStyledTooltip title={this.props.disabled ? this.props.disabledTitle : this.props.btnTooltip}>
						{btn}
					</UIStyledTooltip>
				);
			return btn;
		}

		return button;
	}

	render() {
		const button = this.props.omitBtn ? null : this.getBtn();

		return (
			<div className={clsx("upload-drop-zone-btn-container d-inline-flex", this.props.containerClasses)}>
				{!this.props.omitBtn && (
					<>
						{!!this.props.btnTooltip && (
							<UIStyledTooltip
								title={this.props.disabled ? this.props.disabledTitle : this.props.btnTooltip}
							>
								{button}
							</UIStyledTooltip>
						)}
						{!this.props.btnTooltip && button}
						{this.props.displayLoader && this.state.saving && (
							<div className="ml-2">
								<CircularProgress />
							</div>
						)}
					</>
				)}

				{this.state.dialogOpen && this.props.pageTitle && <UIPageTitle pageTitle={this.props.pageTitle} />}
				<DropzoneDialog
					// onChange={handleChange.bind(this)}
					onSave={handleSave.bind(this)}
					showPreviews={false}
					showAlerts={false}
					dropzoneText={`Drag and drop ${
						this.props.filename || `file${this.props.filesLimit === 1 ? "" : "/s"}`
					} here or click.`}
					onClose={this.handleClose.bind(this)}
					onDrop={onFilesDropped.bind(this)}
					onDropRejected={onFilesRejected.bind(this)}
					clearOnUnmount={true}
					{...this.props}
					maxFileSize={this.maxFileSize}
					open={this.state.dialogOpen}
				/>
			</div>
		);
	}
}
